import { useCallback } from "react";

import { useBrandDiscounts } from "../../../stores/domain/useBrandDiscounts";
import { usePromoBannerStore } from "../../../stores/ui/PromoBannerStore";

import { getFaireDirectFirstOrderIncentiveAmountFields } from "./__internal__/getFaireDirectFirstOrderIncentiveAmountFields";
import { useFaireDirectFirstOrderIncentiveExpiresAtFields } from "./__internal__/useFaireDirectFirstOrderIncentiveExpiresAtFields";
import { useFaireDirectFirstOrderIncentiveHasIncentiveFields } from "./__internal__/useFaireDirectFirstOrderIncentiveHasIncentiveFields";
import { parseFaireDirectFirstOrderIncentiveFromBrandDiscounts } from "./shared/parseFaireDirectFirstOrderIncentiveFromBrandDiscounts";

export const useFaireDirectFirstOrderIncentive = () => {
  const { brandDiscounts, refetch } = useBrandDiscounts();
  const faireDirectFirstOrderIncentive =
    parseFaireDirectFirstOrderIncentiveFromBrandDiscounts(brandDiscounts);

  const {
    brand_token: brandToken,
    brand_name: brandName,
    is_auto_extended: isAutoExtended,
  } = faireDirectFirstOrderIncentive ?? {};

  const hasIncentiveFields =
    useFaireDirectFirstOrderIncentiveHasIncentiveFields(
      faireDirectFirstOrderIncentive
    );

  const expiresAtFields = useFaireDirectFirstOrderIncentiveExpiresAtFields(
    faireDirectFirstOrderIncentive,
    isAutoExtended
  );

  const incentiveAmountFields = getFaireDirectFirstOrderIncentiveAmountFields(
    faireDirectFirstOrderIncentive
  );

  const { setFaireDirectFirstOrderIncentive } = usePromoBannerStore([
    "setFaireDirectFirstOrderIncentive",
  ]);
  const refetchFaireDirectFirstOrderIncentive = useCallback(async () => {
    return refetch()
      .then(({ data }) => {
        setFaireDirectFirstOrderIncentive(data?.brand_discounts);
      })
      .catch(() => {
        setFaireDirectFirstOrderIncentive(undefined);
      });
  }, [refetch, setFaireDirectFirstOrderIncentive]);

  return {
    brandToken,
    brandName,
    isAutoExtended,
    ...hasIncentiveFields,
    ...expiresAtFields,
    ...incentiveAmountFields,
    refetchFaireDirectFirstOrderIncentive,
  };
};
